function patchBVScript(script) {
  try {
    const data = JSON.parse(script.textContent);

    if (script.id === 'bv-jsonld-bvloader-summary') {
      if (!data['@type']) data['@type'] = 'Product';
    }

    if (script.id === 'bv-jsonld-reviews-data') {
      if (!data['@type']) data['@type'] = 'Product';
      if (Array.isArray(data.review)) {
        data.review = data.review.map(review => {
          if (!review['@type']) review['@type'] = 'Review';
          if (review.author && review.author.type && !review.author['@type']) {
            review.author['@type'] = review.author.type;
            delete review.author.type;
          }
          return review;
        });
      }
    }

    script.textContent = JSON.stringify(data);
  } catch (e) {}
}

const BV_IDS = new Set(['bv-jsonld-bvloader-summary', 'bv-jsonld-reviews-data']);
const patched = new Set();

function checkAndPatch() {
  BV_IDS.forEach(id => {
    if (patched.has(id)) return;
    const el = document.getElementById(id);
    if (el) {
      patchBVScript(el);
      patched.add(id);
    }
  });
  if (patched.size === BV_IDS.size) observer.disconnect();
}

const observer = new MutationObserver(checkAndPatch);
observer.observe(document.documentElement, { childList: true, subtree: true });
checkAndPatch();
